"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonaPopup = void 0;
var react_1 = __importDefault(require("react"));
var ActivitySparklineSection_1 = require("./ActivitySparklineSection");
var CoverageGapsSection_1 = require("./CoverageGapsSection");
var EntityPopup_1 = require("./EntityPopup");
var OwnerStatusManagementSection_1 = require("./OwnerStatusManagementSection");
var OwnerContactSection_1 = require("./OwnerContactSection");
var ProvenanceSection_1 = require("./ProvenanceSection");
var RelatedElementsSection_1 = require("./RelatedElementsSection");
var useElementActivationAction_1 = require("./useElementActivationAction");
exports.PersonaPopup = function (_a) {
    var _b;
    var isOpen = _a.isOpen, onDismiss = _a.onDismiss, content = _a.content, role = _a.role;
    var _c = useElementActivationAction_1.useElementActivationAction({
        elementId: content.id,
        role: role,
    }), activationAction = _c.activationAction, toggleError = _c.toggleError;
    var primaryActions = __spreadArrays([
        {
            key: 'close',
            label: 'Close',
            primary: false,
            onClick: onDismiss,
        },
        {
            key: 'save',
            label: 'Save',
            onClick: onDismiss,
        }
    ], (activationAction ? [activationAction] : []));
    var header = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "ws-entity-popup-header-kicker" }, "Persona profile"),
        react_1.default.createElement("div", { className: "ws-entity-popup-header-row" },
            react_1.default.createElement("div", { className: "ws-entity-popup-header-row-title" },
                react_1.default.createElement("span", null, content.name)),
            content.category ? (react_1.default.createElement("div", { className: "ws-entity-popup-header-row-tags" },
                react_1.default.createElement("span", { className: "ws-entity-popup-header-tag ws-entity-popup-header-tag--persona" }, content.category))) : null)));
    return (react_1.default.createElement(EntityPopup_1.EntityPopup, { isOpen: isOpen, onDismiss: onDismiss, role: role, kind: "persona", header: header, primaryActions: primaryActions },
        react_1.default.createElement(OwnerStatusManagementSection_1.OwnerStatusManagementSection, { elementId: content.id, owner: (_b = content.owner) === null || _b === void 0 ? void 0 : _b.name, role: role }),
        react_1.default.createElement("section", { className: "ws-entity-popup-section", "data-section-id": "about" },
            react_1.default.createElement("h4", { className: "ws-entity-popup-section-title" }, "Description"),
            react_1.default.createElement("div", { className: "ws-entity-popup-section-body" }, content.description)),
        content.specificNeeds && content.specificNeeds.length > 0 ? (react_1.default.createElement("section", { className: "ws-entity-popup-section", "data-section-id": "needs" },
            react_1.default.createElement("h4", { className: "ws-entity-popup-section-title" }, "Specific needs"),
            react_1.default.createElement("div", { className: "ws-entity-popup-needs" }, content.specificNeeds.map(function (need) { return (react_1.default.createElement("div", { key: need, className: "ws-entity-popup-needs-item" },
                react_1.default.createElement("span", { className: "ws-entity-popup-needs-icon" },
                    react_1.default.createElement("i", { className: "ms-Icon ms-Icon--CheckMark", "aria-hidden": "true" })),
                need)); })))) : null,
        content.useCases && content.useCases.length > 0 ? (react_1.default.createElement("section", { className: "ws-entity-popup-section", "data-section-id": "use-cases" },
            react_1.default.createElement("h4", { className: "ws-entity-popup-section-title" },
                "Used in use cases",
                typeof content.totalUseCases === 'number' ? (react_1.default.createElement("span", { style: {
                        marginLeft: 8,
                        padding: '1px 8px',
                        borderRadius: 999,
                        background: 'rgba(37,99,235,0.10)',
                        color: '#2563eb',
                        fontSize: 11,
                    } }, content.totalUseCases)) : null),
            react_1.default.createElement("div", { className: "ws-entity-popup-list" }, content.useCases.map(function (uc) { return (react_1.default.createElement("div", { key: uc.id || uc.name, className: 'ws-entity-popup-list-item' +
                    (uc.isCurrent ? ' ws-entity-popup-list-item--current' : '') },
                react_1.default.createElement("div", { className: "ws-entity-popup-list-item-main" },
                    react_1.default.createElement("span", { className: 'ws-entity-popup-list-status ws-entity-popup-list-status--' +
                            (uc.statusColor || 'gray') }),
                    react_1.default.createElement("div", { className: "ws-entity-popup-list-item-text" },
                        uc.href ? (react_1.default.createElement("a", { className: "ws-entity-popup-list-item-title ws-entity-popup-list-item-link", href: uc.href, target: "_blank", rel: "noopener noreferrer" },
                            uc.isCurrent ? (react_1.default.createElement("span", { className: "ws-entity-popup-list-item-current-badge" }, "Current")) : null,
                            uc.name)) : (react_1.default.createElement("span", { className: "ws-entity-popup-list-item-title" },
                            uc.isCurrent ? (react_1.default.createElement("span", { className: "ws-entity-popup-list-item-current-badge" }, "Current")) : null,
                            uc.name)),
                        uc.subtitle ? (react_1.default.createElement("span", { className: "ws-entity-popup-list-item-subtitle" }, uc.subtitle)) : null)),
                react_1.default.createElement("i", { className: "ms-Icon ms-Icon--ChevronRight ws-entity-popup-list-item-trailing-icon", "aria-hidden": "true" }))); })))) : null,
        content.painPointsAddressed && content.painPointsAddressed.length > 0 ? (react_1.default.createElement("section", { className: "ws-entity-popup-section", "data-section-id": "pain-points" },
            react_1.default.createElement("h4", { className: "ws-entity-popup-section-title" },
                "Pain points addressed",
                react_1.default.createElement("span", { style: {
                        marginLeft: 8,
                        padding: '1px 8px',
                        borderRadius: 999,
                        background: 'rgba(220,70,0,0.10)',
                        color: '#dc4600',
                        fontSize: 11,
                    } }, content.painPointsAddressed.length)),
            react_1.default.createElement("div", { className: "ws-entity-popup-chip-row" }, content.painPointsAddressed.map(function (pp) { return (react_1.default.createElement("span", { key: pp, className: "ws-entity-popup-chip ws-entity-popup-chip--pain-point" },
                react_1.default.createElement("i", { className: "ms-Icon ms-Icon--StatusErrorFull", "aria-hidden": "true", style: { color: '#dc4600', fontSize: 12 } }),
                pp)); })))) : null,
        typeof content.metricsCount === 'number' ? (react_1.default.createElement("section", { className: "ws-entity-popup-section", "data-section-id": "metrics" },
            react_1.default.createElement("h4", { className: "ws-entity-popup-section-title" },
                "Metrics",
                react_1.default.createElement("span", { style: {
                        marginLeft: 8,
                        padding: '1px 8px',
                        borderRadius: 999,
                        background: 'rgba(37,99,235,0.10)',
                        color: '#2563eb',
                        fontSize: 11,
                    } }, content.metricsCount)),
            react_1.default.createElement("div", { className: "ws-entity-popup-section-body", style: { color: '#6b7280' } }, "Click \"Open persona dashboard\" to view detailed metrics."))) : null,
        react_1.default.createElement(ProvenanceSection_1.ProvenanceSection, { provenance: content.provenance }),
        react_1.default.createElement(RelatedElementsSection_1.RelatedElementsSection, { related: content.related }),
        react_1.default.createElement(CoverageGapsSection_1.CoverageGapsSection, { gaps: content.coverageGaps }),
        react_1.default.createElement(ActivitySparklineSection_1.ActivitySparklineSection, { heatmap: content.heatmap }),
        react_1.default.createElement(OwnerContactSection_1.OwnerContactSection, { owner: content.owner }),
        toggleError ? (react_1.default.createElement("section", { className: "ws-entity-popup-section", "data-section-id": "toggle-error" },
            react_1.default.createElement("div", { className: "ws-entity-popup-section-body", style: { color: '#dc2626' } }, toggleError))) : null));
};
